import React from 'react';
import { Flex, Typography } from 'antd';
import Image from 'next/image';
import { IHeaderSearchItemProps } from 'tkmp-lib/src/interfaces';
import hsi from './HeaderSearchItem.module.scss';
import { EHeaderSearchItemType } from 'tkmp-lib/src/enums';
import Link from 'next/link';
import Highlighter from 'react-highlight-words';

const HeaderSearchItem = ({
    href = '',
    image,
    title,
    value,
    type,
    searchPrompt,
}: IHeaderSearchItemProps) => {
    return (
        <Link
            href={href}
            className={hsi.container}
        >
            <Flex className={hsi.container_leftSide}>
                <Image
                    className={hsi.container_image}
                    src={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${image}`}
                    width={0}
                    height={0}
                    sizes={'100%'}
                    alt={''}
                />
            </Flex>
            <Flex
                vertical
                className={hsi.container_rightSide}
            >
                <Highlighter
                    className={`text-14-300 text-[#0B0B0C] ${hsi.rightSide__title}`}
                    highlightStyle={{
                        fontSize: '14px',
                        fontWeight: '500',
                        background: 'transparent',
                    }}
                    searchWords={searchPrompt?.split(' ')}
                    autoEscape={true}
                    textToHighlight={title}
                />
                <Typography.Text
                    className={`${type === EHeaderSearchItemType.Product ? `text-14-500 text-[#0B0B0C]` : `text-14-400 text-[#7B7C7D]`} ${hsi.rightSide__value}`}
                >
                    {value}
                </Typography.Text>
            </Flex>
        </Link>
    );
};

export default HeaderSearchItem;
